import { Table } from 'coreOld/components';
import withSelectionPanel from 'coreOld/components/withSelectionPanel';
import { TableNames } from 'coreOld/constants';
import { ISelectionPanelProps } from 'coreOld/types';
import { IManufacturer } from 'partsOld/types';

import { columns } from './columns';
import AssignManufacturerModal from '../AssignManufacturerModal';

interface IProps extends ISelectionPanelProps<any> {
  fetchNextPage;
  hasNextPage: boolean;
  isLoading: boolean;
  isFetchingNextPage: boolean;
  onAssignClose: () => void;
  isAssignOpen: boolean;
  onAssignManufacturer: (selectedItems: any, manufacturer: IManufacturer) => Promise<void>;
  filters;
  records;
}

const ChooseManufacturerTableView = ({
  isFetchingNextPage,
  isLoading,
  isModalOpen,
  selectedRows,
  setSelectedRows,
  records,
  onCheckboxClick,
  hasNextPage,
  fetchNextPage,
  onAssignClose,
  isAssignOpen,
  filters,
  onAssignManufacturer,
}: IProps) => {
  return (
    <>
      <Table
        columns={columns}
        data={records}
        name={TableNames.IMPORT_CHOOSE_MANUFACTURER}
        setSelectedRows={setSelectedRows}
        onCheckboxClick={onCheckboxClick}
        isModalOpen={isModalOpen}
        alternating={false}
        borderBottom={true}
        hasRowSelection={true}
        hasFilters={true}
        isLoading={isLoading}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        fetchNextPage={fetchNextPage}
        headerLines={2}
      />

      <AssignManufacturerModal
        isOpen={isAssignOpen}
        onClose={onAssignClose}
        filters={filters}
        onAssignManufacturer={onAssignManufacturer}
        selectedItems={selectedRows}
      />
    </>
  );
};

export default withSelectionPanel(ChooseManufacturerTableView);
